// extracted by mini-css-extract-plugin
export default {"favorite":"favorite_favorite__44nhS","active":"favorite_active__g-Bis"};